/**
 *
 * @param {string} value
 * @return {boolean}
 */
export function isStringBoolean(value) {
    return value === '1'
}

/**
 *
 * @param {object[]} data
 * @param {string} idKey
 * @param {string} parentKey
 * @param {string} subKey
 * @param {string?} sortKey
 * @returns {object[]}
 */

export function objectArrayReduceTree(data, idKey, parentKey, subKey, sortKey) {
    const elementMap = new Map()
    for (const element of data) {
        elementMap.set(element[idKey], {...element, [subKey]: []})
    }

    const rootElements = []
    for (const element of elementMap.values()) {
        const parentId = element[parentKey]
        if (parentId === 0) {
            rootElements.push(element)
            continue
        }

        const parentElement = elementMap.get(parentId)
        parentElement[subKey] = (parentElement[subKey] ?? []).concat(element)
    }

    if (sortKey) {
        for (const element of elementMap.values()) {
            const parentId = element[parentKey]
            if (parentId === 0) {
                continue
            }

            const parentElement = elementMap.get(parentId)
            parentElement[subKey] = parentElement[subKey].sort((elem1, elem2) => {
                const [sort1, sort2] = [elem1[sortKey], elem2[sortKey]]
                if (sort1 < sort2) {
                    return -1
                }

                if (sort1 > sort2) {
                    return 1
                }

                return 0
            })
        }
    }

    return rootElements
}
